import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteGovernmentAllocationDistribution } from '@/features/privateCompanies/hooks/useDeleteGovernmentAllocationDistribution'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

interface GovernmentAllocationDistributionDeleteModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  distributionId?: string
}

export const GovernmentAllocationDistributionDeleteModal = ({
  isOpen,
  setIsOpen,
  distributionId,
}: GovernmentAllocationDistributionDeleteModalProps) => {
  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsBranchesToDistribute'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsAllowedCategoriesAndProducts'] })
  }

  const { mutate: deleteDistribution, isPending: deleteDistributionIsPending } =
    useDeleteGovernmentAllocationDistribution({
      onSuccess,
      onError: (error) => {
        setIsOpen(false)
        FormTransformers.errorsTransformer({ setMessages })(error)
      },
    })

  return (
    <>
      <Modal
        triggerAsChild
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Remover divisão de crédito"
        disabled={deleteDistributionIsPending}
        confirmButtonIsLoading={deleteDistributionIsPending}
        onConfirm={() => deleteDistribution(distributionId)}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
